module.exports = __webpack_public_path__ + "static/img/fruits_pine.5221f28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_pine.png
// module id = W/bf
// module chunks = 1